import { render, staticRenderFns } from "./SearchResult.vue?vue&type=template&id=a273f880&scoped=true&"
import script from "./SearchResult.vue?vue&type=script&lang=ts&"
export * from "./SearchResult.vue?vue&type=script&lang=ts&"
import style0 from "./SearchResult.vue?vue&type=style&index=0&id=a273f880&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a273f880",
  null
  
)

export default component.exports